import { Component } from '@angular/core';

@Component({
  selector: 'skeleton-list',
  templateUrl: 'skeleton-list.html'
})
export class SkeletonListComponent {

  constructor() {
  }

}



// WEBPACK FOOTER //
// ./src/components/skeleton-list/skeleton-list.ts